import React from 'react';
import Utils from '../../utils/utils';

const CreditCardDescription = () => (
    <div className="row credit-card-description">
        <div className="col-md-5">
            <div className="card-icons">
                <img src={`${Utils.getAssetsDomain()}/images/website/subscription/visa.svg`} />
                <img src={`${Utils.getAssetsDomain()}/images/website/subscription/mastercard.svg`} />
                <img src={`${Utils.getAssetsDomain()}/images/website/subscription/discover.svg`} />
                <img src={`${Utils.getAssetsDomain()}/images/website/subscription/american.svg`} />
            </div>
        </div>
    </div>
);

export default CreditCardDescription;
